import type { CentrifugeMessage } from '../messageTypes';

export interface CastGuestImgBlindOnMessage {
  // 해당 인터페이스를 찾을 수 없으므로 수정 필요함
  data: {
    type: 'CastGuestImgBlindOn';
    message: { name: string; type: string };
    created_at?: number;
  };
  offset: number;
}

export const isCastGuestImgBlindOnMessage = (item: CentrifugeMessage): item is CastGuestImgBlindOnMessage => {
  return 'data' in item && item.data.type === 'CastGuestImgBlindOn';
};

export interface BlindOnMessage {
  // 해당 인터페이스를 찾을 수 없으므로 수정 필요함
  data: {
    type: 'BlindOn';
    message: { name: string; type: string };
    created_at?: number;
  };
  offset: number;
}
export const isBlindOnMessage = (item: CentrifugeMessage): item is BlindOnMessage => {
  return 'data' in item && item.data.type === 'BlindOn';
};

export interface BlindOffMessage {
  // 해당 인터페이스를 찾을 수 없으므로 수정 필요함
  data: {
    type: 'BlindOff';
    message: { type: string; name: string };
    created_at?: number;
  };
  offset: number;
}
export const isBlindOffMessage = (item: CentrifugeMessage): item is BlindOffMessage => {
  return 'data' in item && item.data.type === 'BlindOff';
};

export interface CastPauseMessage {
  data: {
    type: 'CastPause';
    message: object;
    created_at?: number;
  };
  offset: number;
}
export const isCastPauseMessage = (item: CentrifugeMessage): item is CastPauseMessage => {
  return 'data' in item && item.data.type === 'CastPause';
};
export type BlindMessage =
  | BlindOnMessage
  | BlindOffMessage
  | CastGuestImgBlindOnMessage
  | CastPauseMessage
  | ServiceBlindOnMessage
  | ServiceBlindOffMessage;
export const isBlindTypes = (item: CentrifugeMessage): item is BlindMessage => {
  return (
    'data' in item &&
    (item.data.type === 'BlindOn' ||
      item.data.type === 'BlindOff' ||
      item.data.type === 'CastGuestImgBlindOn' ||
      item.data.type === 'CastPause' ||
      item.data.type === 'ServiceBlindOn' ||
      item.data.type === 'ServiceBlindOff')
  );
};

export interface CastResumeMessage {
  data: {
    type: 'CastResume';
    message: object;
    created_at?: number;
  };
  offset: number;
}
export const isCastResumeMessage = (item: CentrifugeMessage): item is CastResumeMessage => {
  return 'data' in item && item.data.type === 'CastResume';
};

export interface ServiceBlindOnMessage {
  channel: string;
  data: {
    type: 'ServiceBlindOn';
    message: { name: string; site: string };
    created_at?: number;
  };
  offset: number;
}

export const isServiceBlindOnMessage = (item: CentrifugeMessage): item is ServiceBlindOnMessage => {
  return 'data' in item && item.data.type === 'ServiceBlindOn';
};

export interface ServiceBlindOffMessage {
  channel: string;
  data: {
    type: 'ServiceBlindOff';
    message: { name: string; site: string };
    created_at?: number;
  };
  offset: number;
}

export const isServiceBlindOffMessage = (item: CentrifugeMessage): item is ServiceBlindOffMessage => {
  return 'data' in item && item.data.type === 'ServiceBlindOff';
};
